(function (mod) {
	if (typeof exports === "object") {
		module.exports = mod();
	}else{
		window.Mo = mod();
	}
})(function (){
var Mo = (function (){

/////////////////////////////////////////////////////////////////////////
// ↓ Star Class ↓
/////////////////////////////////////////////////////////////////////////
var S=function(C,s,p){
    this.x=p.x;
    this.y=p.y;
    
    var c=0;
    this.level=p.level;
    /*
    switch(this.level){
        case 1:c="#00f";break;
        case 2:c="#0ff";break;
        case 3:c="#0f0";break;
        case 4:c="#ff0";break;
        case 5:c="#f00";break;
    }
    
    this.size=(_.random(0,3)>1)?2:1;
	this.graphics = new createjs.Graphics().beginFill(c).drawRect(-1/2*this.size, -1/2*this.size, this.size, this.size);
    this.shape = new createjs.Shape(this.graphics);
    this.shape.cache(-1,-1,2,2);
    */
    
    this.star=new createjs.Bitmap(s);
    if(this.level===0){
        //Q.count("stars");
        this.scale=C.size.baseScale*Math.random()*0.3
        this.star.scaleX=this.scale;
        this.star.scaleY=this.scale;
    }else{
        this.scale=C.size.baseScale*0.35*3/4;
    }
    
    this.star.set({
        x:p.x,
        y:p.y,
        regX:30,
        regY:30,
        scaleX:this.scale,
        scaleY:this.scale
    })
	this.initial=_.random(0,60);
    this.level=p.level;
}
S.prototype.up=function(step,max){
	//O.put("count",this.count);
	if(step%60===this.initial){
		this.star.visible=false;
	}else{
		this.star.visible=true;
    }
    if(this.level!=0){
        this.star.rotation-=1;
    }
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
return S;
/////////////////////////////////////////////////////////////////////////

})();
return Mo;
});


